import React from 'react';

export default function SubBannerMugClubLg() {
    return (
        <div id='MugClub' className='subBanner'>
            <div className='subBannerHalf1 subBannerHalf1Lg'>
                <div className='subBannerText'>
                    <h1 className='header'>The Mug Club</h1>
                    <p>Be one of the cool kids on the block! Purchase a Tory's Diner mug for yourself and always get free refills of our delicious coffee. Ask Tory about the Mug Club during your visit!</p>
                </div>
            </div>
            <div className='subBannerHalf2 subBannerHalf2Lg mugClubPic'>
            </div>
        </div>
    )
}